/**
 * Brand loading state: Sovrynn icon mark (two lines) with subtle pulse.
 */
import React from 'react';
import SovrynnIcon from './SovrynnIcon';
import './brand.css';

export default function BrandLoading({ message = 'Loading...' }) {
  return (
    <div className="brand-loading">
      <div className="brand-loading__icon">
        <SovrynnIcon size="ico-lg" />
      </div>
      {message && <p className="brand-loading__message">{message}</p>}
    </div>
  );
}
